import React from "react"
import { connect } from "react-redux"
import { createMatchSelector } from "react-router-redux"
import { graphql } from "react-apollo"
import gql from "graphql-tag"
import ErrorBoundary from "../ErrorBoundary"
import HeaderWithRouteEntity from "./HeaderWithRouteEntity"
import HeaderWithDefaultEntity from "./HeaderWithDefaultEntity"
import ReactGA from "react-ga"
import Header from "."
import PropTypes from "prop-types"
import routes from "../../routes"
import UserNav from "../UserNav"

let userSet = false

// Add user context for analytics.
/* istanbul ignore next */
const initFullStory = user => {
  if (window["FS"]) {
    window["FS"].setUserVars({
      uid: user.id,
      displayName: `${user.firstName} ${user.lastName}`,
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
      healthcareRole: user.healthcareRole,
      departmentId: user.department.id,
      departmentName: user.department.name,
      facilityId: user.facility.id,
      facilityName: user.facility.name,
    })
  }
}

const ContextualHeader = props =>
  props.match ? (
    <HeaderWithRouteEntity
      userInitials={props.userInitials}
      applications={props.applications}
    />
  ) : (
    <HeaderWithDefaultEntity
      userInitials={props.userInitials}
      applications={props.applications}
    />
  )

ContextualHeader.propTypes = {
  match: PropTypes.object,
  userInitials: UserNav.propTypes.initials,
  applications: UserNav.propTypes.applications,
}

const ContextualHeaderWithApollo = graphql(
  gql`
    query LoggedInUser {
      user {
        id
        email
        firstName
        lastName
        healthcareRole
        department {
          id
          name
        }
        facility {
          id
          name
        }
        applications {
          name
          url
        }
      }
    }
  `,
  {
    props: ({ data: { error, loading, user } }) => {
      if (error) {
        throw error
      }
      if (!loading) {
        if (!userSet) {
          ReactGA.set({
            userId: user.id,
            dimension1: user.id,
            dimension2: user.facility.id,
          })
          initFullStory(user)
          userSet = true
          /* istanbul ignore next */
          if (process.env.NODE_ENV === "production")
            window.Raven.setUserContext({
              id: user.id,
            })
        }

        return {
          userInitials: `${user.firstName[0]}${user.lastName[0]}`,
          applications: user.applications
            .map(({ name, ...rest }) => ({ text: name, ...rest }))
            .filter(app => app.text !== "Nursing Insights"),
        }
      }
    },
  }
)(ContextualHeader)

const ContextualHeaderWithStore = connect(({ router }) => ({
  match: createMatchSelector(routes.entity)({ router }),
}))(ContextualHeaderWithApollo)

// Export a safe header that will render no matter what api/dom errors might occur.
export default () => (
  <ErrorBoundary errorComponent={Header}>
    <ContextualHeaderWithStore />
  </ErrorBoundary>
)
